import styled from 'styled-components';

export const ItemHeader = styled.header`
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > .title-container {
    & > span {
      font-size: 0.625rem;
    }

    & > .select-month {
      margin: 0.5rem 0;
    }
  }

  & button.dots-button {
    color: ${({ theme }) => theme.colors.grayDark2};
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
    box-shadow: none;
  }

  & > .dropdown-actions {
    display: block;
  }

  & > .actions {
    display: flex;
    align-items: center;
    column-gap: 1rem;
    width: 17.625rem;

    & > button:first-child {
      width: 6.125rem;
    }

    & > button:nth-child(2) {
      width: 10.5rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    & > .actions {
      display: flex;
      align-items: center;
    }

    & > .dropdown-actions {
      display: none;
    }
  }
`;

export const ContentDateField = styled.div`
  max-width: 10.75rem;
`;
